import { Check as MCheckIcon } from '@mui/icons-material'

interface CheckIconProps {
  className?: string
}

export const CheckIcon: React.FC<CheckIconProps> = ({ className }) => {
  return <MCheckIcon className={className} />
}
